<template>
<div class="chapter">
<div class="inner_page">
<section class="chapter" epub:type="frontmatter" id="ser">
<p class="sert" style="text-align:center;"><span aria-label="ii" class="page" id="pii" role="doc-pagebreak"></span>Plan of the Collected Works</p>
<p class="serau" style="text-align:center;">Edited by Bruce Caldwell</p>
<table style="border-bottom:0;">
<tbody><tr>
<td>
<p class="td">Volume I</p>
</td>
<td>
<p class="td">The Fatal Conceit: The Errors of Socialism (1988)</p>
</td>
</tr>
<tr>
<td>
<p class="td">Volume II</p>
</td>
<td>
<p class="td">The Road to Serfdom: Text and Documents—The Definitive Edition (2007)</p>
</td>
</tr>
<tr>
<td>
<p class="td">Volume III</p>
</td>
<td>
<p class="td">The Trend of Economic Thinking: Essays on Political Economists and Economic History (1991)</p>
</td>
</tr>
<tr>
<td>
<p class="td">Volume IV</p>
</td>
<td>
<p class="td">The Fortunes of Liberalism: Essays on Austrian Economics and the Ideal of Freedom (1992)</p>
</td>
</tr>
<tr>
<td>
<p class="td">Volume V</p>
</td>
<td>
<p class="td">Good Money, Part I: The New World (1999)</p>
</td>
</tr>
<tr>
<td>
<p class="td">Volume VI</p>
</td>
<td>
<p class="td">Good Money, Part II: The Standard (1999)</p>
</td>
</tr>
<tr>
<td>
<p class="td">Volume VII</p>
</td>
<td>
<p class="td">Business Cycles, Part I (2012)</p>
</td>
</tr>
<tr>
<td>
<p class="td">Volume VIII</p>
</td>
<td>
<p class="td">Business Cycles, Part II (2012)</p>
</td>
</tr>
<tr>
<td>
<p class="td">Volume IX</p>
</td>
<td>
<p class="td">Contra Keynes and Cambridge: Essays, Correspondence (1995)</p>
</td>
</tr>
<tr>
<td>
<p class="td">Volume X</p>
</td>
<td>
<p class="td">Socialism and War: Essays, Documents, Reviews (1997)</p>
</td>
</tr>
<tr>
<td>
<p class="td">Volume XI</p>
</td>
<td>
<p class="td">Capital and Interest (2015)</p>
</td>
</tr>
<tr>
<td>
<p class="td">Volume XII</p>
</td>
<td>
<p class="td">The Pure Theory of Capital (2007)</p>
</td>
</tr>
<tr>
<td>
<p class="td">Volume XIII</p>
</td>
<td>
<p class="td">Studies on the Abuse and Decline of Reason: Text and Documents (2010)</p>
</td>
</tr>
<tr>
<td>
<p class="td">Volume XIV</p>
</td>
<td>
<p class="td">The Sensory Order and Other Writings on the Foundations of Theoretical Psychology (2017)</p>
</td>
</tr>
<tr>
<td>
<p class="td">Volume XV</p>
</td>
<td>
<p class="td">The Market and Other Orders (2014)</p>
</td>
</tr>
<tr>
<td>
<p class="td">Volume XVI</p>
</td>
<td>
<p class="td">Hayek on Mill: The Mill-Taylor Friendship and Related Writings (2015)</p>
</td>
</tr>
<tr>
<td>
<p class="td">Volume XVII</p>
</td>
<td>
<p class="td">The Constitution of Liberty: The Definitive Edition (2011)</p>
</td>
</tr>
<tr>
<td>
<p class="td">Volume XVIII</p>
</td>
<td>
<p class="td">Essays on Liberalism and the Economy (2021)</p>
</td>
</tr>
<tr>
<td>
<p class="td">Volume XIX</p>
</td>
<td>
<p class="td">Law, Legislation, and Liberty (2021)</p>
</td>
</tr>
<tr>
<td>
<p class="td"><i>Supplement</i></p>
</td>
<td>
<p class="td">Hayek on Hayek: An Autobiographical Dialogue (1994)</p>
</td>
</tr>
</tbody></table>
<p class="serpf">The plan is provisional. Minor alterations may occur in titles of individual books, and several additional volumes may be added.</p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chi-hayek-vol19-0003.vue?32503762